define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/data/ItemFileWriteStore",
	"dojo/dom-construct",
	"src/c8-platform/type/value",
	"underscore",
	"csi",
	"csi/def",
	"csi/def/Field",
	"csi/heading/_base",
	"csi/form/Widget",
	"csi/html",
	"csi/locale",
	"csi/reflection",
	"csi/service/writerService",
	"csi/xml",
	"csi/xml/Writer"
], function(array, declare, lang, ItemFileWriteStore, domConstruct, {isEnumValueType, isRefValueType}, _, csi, def, Field, csiHeading, Widget, html, locale, reflection, {writeFormFields}, xml, Writer) {
	// If modifying this behavior also update Merchandising/MerchProductCopyTemplateForm.js

	var _localePrefix = "CopyOption-";

	const STYLE = "Style";

	function _stripUnderscore(s) {
		if (s && s.charAt(0) == '_') {
			s = s.substring(1);
		}

		return s;
	}

	function _isStyleAttribute(field) {
		return !!reflection.getTypeAttribute(STYLE, _stripUnderscore(field));
	}

	function _isCopyOptionAttribute(field) {
		return !!reflection.getTypeAttribute("StyleCopyOptions", field);
	}

	function _getOptionLocaleName(optGroupName, optName) {
		var localValue = locale.resource(_localePrefix + optGroupName + "." + optName);
		var localOptName;

		if (optGroupName == "CopiedStyleSampleTypes") {
			return locale.getEnumName(optName);
		}

		if (localValue.indexOf(_localePrefix, 0) < 0) {
			var b = localValue.split(".");
			localOptName = (b.length > 1 ? b[1] : optName);
		} else {
			// There is no localized value
			localValue = locale.resource(_localePrefix + optGroupName);

			if (localValue.indexOf(_localePrefix, 0) < 0) {
				// Must be a type name (for options with filtered types)
				localOptName = locale.type(optName);
			}
		}

		// Be sure localized option name is not empty
		if (!localOptName || !localOptName.length) {
			localOptName = optName;
		}

		return localOptName;
	}

	function _getBooleanMapLabel(/*Field*/field, /*Node*/copyOptionsNode) {
		var id = field.m_id;
		var optGroupName = id.substring(1);
		var optName;

		_.some(copyOptionsNode[id], function(value, key) {
			optName = key;
			return true;
		});

		var localValue = locale.resource(_localePrefix + optGroupName + "." + optName);
		var localOptGroupName;

		if (localValue.indexOf(_localePrefix, 0) < 0) {
			var b = localValue.split(".");
			localOptGroupName = (b ? b[0] : optGroupName);
		} else {
			// There is no localized value
			localValue = locale.resource(_localePrefix + optGroupName);

			if (localValue.indexOf(_localePrefix, 0) < 0) {
				// Must be a type!
				localOptGroupName = localValue;
			}
		}

		// Be sure it's not empty
		if (!localOptGroupName || !localOptGroupName.length) {
			localOptGroupName = optGroupName;
		}

		return localOptGroupName;
	}

	function _getBooleanMapStore(/*Field*/field, /*Node*/copyOptionsNode) {
		var id = field.m_id;
		var optGroupName = id.substring(1);
		var children = [];
		var mainValue = false;

		// Create items for tree store
		_.each(copyOptionsNode[id], function(value, key) {
			if (value && !mainValue) {
				mainValue = true;
			}

			children.push({
				id: key,
				name: _getOptionLocaleName(optGroupName, key),
				type: "leaf",
				iconClass: "checkboxTreeIcon",
				value: value,
				checkbox: {
					// need to define _type so that object is not interpreted as store item
					_type: "object",

					// must be always false for template!
					disabled: false
				}
			});
		});

		var store = null;

		// No options for group, so don't add
		if (children.length > 0) {
			// Always create new store and corresponding items
			var storeItems = [];

			store = new ItemFileWriteStore({
				data: {
					identifier: "id",
					label: "name",
					items: storeItems
				}
			});

			storeItems.push({
				id: id,
				name: "",
				type: "group",
				children: csi.sort(children, "name"),
				iconClass: "checkboxTreeIcon",
				labelClass: "treeNodeLabelGroup",
				value: mainValue,
				checkbox: {_type: "object", disabled: false}
			});
		}

		return store;
	}

	return declare(Widget, {
		isFieldEditable: function(/*Field*/field) {
			// summary: all fields on template form should be edit-able
			return true;
		},

		areSameFieldIds: function(/*String*/fieldOrAttrId1, /*String*/fieldOrAttrId2) {
			// summary: returns true if field/attribute ids are the same.
			// Strip the leading underscore and compare the rest
			return _stripUnderscore(fieldOrAttrId1) == _stripUnderscore(fieldOrAttrId2);
		},

		/**
		 * @override
		 * Return field for given field name (or field itself)
		 * @param {Field} field 
		 * @return {field}  
		 */
		getField: function(field) {
			if (typeof field === "string") {
				return this.inherited(arguments) || this.inherited(arguments, ["_".concat(field)]);
			}

			return field;
		},

		getFieldStore: function(/*Field*/field, /*String*/value) {
			const isEnum = isEnumValueType(field.m_type);
			const isRef = isRefValueType(field.m_type);
			// summary: return store for boolean maps if it exists
			if (field.m_typeControl == def.FIELD_CHECKBOX_MAP) {
				return _getBooleanMapStore(field, this.getFormSourceNode());
			}
			if (isEnum || isRef) {
				let store;
				let url;
				const ctx = this.getFormContext();
				const {heading} = field;
				csiHeading.applyHeadingRenderer(ctx, heading, (renBase, hBase) => {
					if (renBase && renBase.getStore) {
						store = renBase.getStore(ctx, hBase, value, true);
						const params = store?.aggregateStoreParams;
						if (params) {
							if (_isStyleAttribute(field.m_id)) {
								url = xml.getClientNodeUrl(STYLE);
								params.actionNodeType = STYLE;
							} else {
								const sourceNode = this.getFormSourceNode()
								url = sourceNode?.$URL || this.getFormNodeUrl();
								params.actionNodeType = this.getFormNodeType();
							}

							params.sourceUrl = url;
							params.reportOperations = this._getFormReportNodeOperations(field, url);
							params.actionType = "NEW";


							// add callback when response is ready to store with field
							store.onAggregateStoreResponse = (res) => {
								field.aggregateStoreResponse = res;
							};
						} else {
							// reset response just in case store changes from using an aggregate store to not using one
							field.aggregateStoreResponse = null;
						}
					}
				});
				// create empty store if none yet
				return store || this.createHeadingNamesStore(ctx || this.getContext(), field, value);
			}
		},

		_resolveView: function() {
			// summary: add fields for options if not already there
			this.inherited(arguments);

			var copyOptionsNode = this.getFormSourceNode();
			if (!copyOptionsNode)
				return;

			// overwrite report node flags so that fields are seen as editable
			copyOptionsNode.$FG = 0;

			// Copy options node class and localization map
			var rc = reflection.getNodeClass(copyOptionsNode);
			var lmap = this.defView.getLocaleMap(rc);
			var copiedNodeRC = reflection.getClass(copyOptionsNode.RootType);
			var copiedNodeLMap = this.defView.getLocaleMap(copiedNodeRC);

			array.forEach(copyOptionsNode.Index, function(id) {
				if (!this.defView.getField(id)) {
					// add field if not configured in form
					var field = lang.mixin(new Field(), {m_id: id});
					var optionType = copyOptionsNode[id + "OptionType"];

					if (optionType == "VOPT") {
						this._resolveValueOptionField(field, copyOptionsNode, copiedNodeLMap, copiedNodeRC, null);
					} else {
						var type = xml.nodeAttributeGetType(copyOptionsNode, id);
						field.m_type = type;
						field.resolve(lmap, rc, copyOptionsNode);

						// BooleanMap requires specialized handling
						if (type == xml.ATTR_BOOLEANMAP) {
							field.m_label = _getBooleanMapLabel(field, copyOptionsNode);
						}
					}

					this.insertField(field);
				}
			}, this);

			// Add metadata fields
			array.forEach([].concat(this.defView.m_fields), function(field) {
				// Locked
				field._lockedField = this._addMetaDataField(copyOptionsNode, field.m_id + "Locked");
				field._lockedField.resolve(lmap, rc, copyOptionsNode);

				// Initialized from source
				if (copyOptionsNode[field.m_id + "OptionType"] == "VOPT") {
					field._initializedFromSourceField = this._addMetaDataField(copyOptionsNode, field.m_id + "InitializedFromSource");
					field._initializedFromSourceField.resolve(lmap, rc, copyOptionsNode);
				}
			}, this);
		},

		_addMetaDataField: function(/*Node*/node, /*String*/id) {
			var f = lang.mixin(new Field(), {
				m_id: id,
				m_name: id,
				m_typeControl: def.FIELD_CHECKBOX,
				_metaDataField: true
			});

			this.addDefaultValue(id, node[id]);
			this.insertField(f);

			return f;
		},

		/**
		 * @override
		 * Return report nodes operations script to publish changes in form
		 * @param {cnl} nodeUrl - report node url which will only be an existing url in the Edit case
		 * @return {string}
		 */
		_getFormReportNodeOperations: function(field, nodeUrl) {
			const {defView} = this;
			const formNode = this.getFormNode();
			const type = _isCopyOptionAttribute(field.m_id) ? this.getFormNodeType() : STYLE;
			const writer = new Writer();
			writer.setReport();

			//if New or Copy case, then create new node
			writer.createNode(nodeUrl, type);
			// write node operations for form fields that are attributes
			writeFormFields(
				writer,
				nodeUrl,
				defView.m_fields,
				false,
				(f) => this._canWriteFormReportForField(field, f),
				(f) => this._getFormReportFieldValue(f),
				(f) => this._getFormReportAttributeId(f)
			);
			return writer.serialize();
		},

		/**
		 * @override
		 * Return true if able to write form report for field
		 * @param {Field} field - creating the aggregate store for
		 * @param {f} f - write the operation for
		 * @return {boolean}
		 */
		_canWriteFormReportForField(field, f) {
			if (_isStyleAttribute(f.m_id) && _isStyleAttribute(field.m_id) && f.m_type != xml.ATTR_BOOLEANMAP) {
				return true;
			} else if (_isCopyOptionAttribute(f.m_id) && _isCopyOptionAttribute(field.m_id)) {
				return true;
			}
			return false;
		},

		/**
		 * @override
		 * Return value to be published for field
		 * @param {Field} field
		 * @return {C8AttributeValue}
		 */
		_getFormReportFieldValue(field) {
			return field.getValue();
		},


		/**
		 * Return Id to be published for field
		 * @param {Field} field
		 * @return {C8AttributeId}
		 */
		_getFormReportAttributeId(field) {
			return _isStyleAttribute(field.m_id) ? _stripUnderscore(field.m_id) : field.m_id;
		},

		_resolveValueOptionField: function(/*Field*/field, /*Node*/copyOptionsNode, /*LocaleResolver*/lr, /*Class*/rcRoot, /*Node*/nodeRoot) {
			var targetId = _stripUnderscore(field.m_id);  // Remove leading underscore

			var type = xml.nodeAttributeGetType(copyOptionsNode, field.m_id);
			field.resolveWithParameters(lr, rcRoot, nodeRoot, targetId, targetId, type);
			field.m_bRequired = false;

			var h = field.heading;
			if (h && !h._rca) {
				h._rca = field.m_rca;
			}
		},

		_buildField: function(/*Context*/ctx, /*Field*/field, /*DOMNode*/tr, /*DOMNode?*/tdControl) {
			// summary: add additional dynamic meta data fields

			// don't add the metadata field as a regular field
			if (field._metaDataField)
				return;

			this.inherited(arguments);

			if (field.m_id == xml.ATTR_NAME)
				return;

			if (tr == tr.parentNode.firstChild) {
				// add meta data headers
				html.create("th", {
					innerText: locale.resource("Copy-Locked"),
					style: "padding: 0 20px"
				}, tr);

				html.create("th", {
					innerText: locale.resource("Copy-InitializedFromSource"),
					style: "padding: 0 20px"
				}, tr);
			} else if (!tdControl) {
				// add metadata fields if exist

				// Locked
				this._buildMetaDataField(ctx, field._lockedField, tr);

				// Initialized from source
				this._buildMetaDataField(ctx, field._initializedFromSourceField, tr);
			}
		},

		_buildMetaDataField: function(/*Context*/ctx, /*Field*/f, /*DOMNode*/tr) {
			if (f) {
				Widget.prototype._buildField.call(this, ctx, f, tr, domConstruct.create("td", {
					"class": "csiFormViewValue csiFormViewValueExtra",
					style: "text-align: center"
				}, tr));
			}
		},

		_buildFields: function(/*Field[]*/fields) {
			// summary: build header field
			fields.unshift(lang.mixin(new Field(), {
				m_label: "",
				m_typeControl: def.FIELD_COMMENT
			}));

			this.inherited(arguments);
		}

	});
});